/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PricePolicyOverviewPage = lazyLoad(
  () => import('./index'),
  module => module.PricePolicyOverviewPage
);
